import type { IOrganizationFeatureClientPortal } from './OrganizationFeatureClientPortal.interface';
import OrganizationFeatureClientPortalDisplay from './OrganizationFeatureClientPortalDisplay';
import OrganizationFeatureClientPortalNotifications from './OrganizationFeatureClientPortalNotifications';
import OrganizationFeatureClientPortalSystem from './OrganizationFeatureClientPortalSystem';

export default class OrganizationFeatureClientPortal
  implements IOrganizationFeatureClientPortal {
  system: OrganizationFeatureClientPortalSystem;
  display: OrganizationFeatureClientPortalDisplay;
  notifications: OrganizationFeatureClientPortalNotifications;

  static build = (data: IOrganizationFeatureClientPortal) =>
    new OrganizationFeatureClientPortal(data);

  static blank = () => new OrganizationFeatureClientPortal();

  /**
   * Constructor
   * @param {IOrganizationFeatureClientPortal} data
   */
  constructor(data?: IOrganizationFeatureClientPortal) {
    this.system = new OrganizationFeatureClientPortalSystem(data?.system);
    this.display = new OrganizationFeatureClientPortalDisplay(data?.display);
    this.notifications = new OrganizationFeatureClientPortalNotifications(data?.notifications);
  }
}
